import { RoleData } from './RoleData';
import type { IProfileData } from './server/model/IProfileData';

export class ProfileData {
    Id: string;
    FirstName?: string;
    LastName?: string;
    UserName: string;
    IsAccountAdmin: boolean;
    TromanRoles: RoleData;
    ValmanRoles: RoleData;

    name: string;

    constructor(json: IProfileData) {
        //if (!json) return;

        this.Id = json.Id;
        this.FirstName = json.FirstName;
        this.LastName = json.LastName;
        this.UserName = json.UserName;

        this.IsAccountAdmin = json.Permissions.IsAccountAdmin;
        this.TromanRoles = new RoleData(json.Permissions.TromanRoles);
        this.ValmanRoles = new RoleData(json.Permissions.ValmanRoles);

        if (this.LastName != null) {
            if (this.FirstName != null) {
                this.name = this.FirstName + ' ' + this.LastName;
            } else {
                this.name = this.LastName;
            }
        } else {
            this.name = this.UserName;
        }
    }
}
